import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-laravelhorizon',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Laravel Horizon icon</title><path d="M20.486 3.516C15.8-1.171 8.202-1.172 3.516 3.513A11.963 11.963 0 0 0 0 11.998a11.975 11.975 0 0 0 4.2 9.13h.01a12 12 0 0 0 16.274-.642c4.687-4.685 4.688-12.283.002-16.97zM16 13.998c-4 0-4-4-8-4-2.5 0-3.44 1.565-4.765 2.74H3.23a8.801 8.801 0 0 1 17.54-1.48c-1.33 1.175-2.27 2.74-4.77 2.74z"/></svg>`,
    styles: []
})
export class SimpleIconsLaravelhorizonComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#405263';
    @Input() className: string = 'simple-icons-laravelhorizon'
    constructor() {}
    ngOnInit(): void {}
}
